jQuery(document).ready(function ($){   

  /* Userway */
       document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });

    // Mega Menu
    $('.mega-menu li').attr('id', function() {
      return 'id_' + $(this).index();
    });
  
    // Universal Header Link Tracking
  	$(".universal-header li a").attr("href", function(i, href) {
       return href + '?utm_source=amc-shop&utm_medium=referral&utm_campaign=top-nav';
    });

    // Account Disclaimer Popup
    $('.account-disclaimer-button').click(function(){
      $('.account-disclaimer-overlay, .account-disclaimer').css("visibility", "visible");
    });
    $('#account-disclaimer-close, .account-disclaimer-overlay, .account-disclaimer-footer').click(function(){
        $('.account-disclaimer-overlay, .account-disclaimer').css("visibility", "hidden");
    });

    // Snow Slides
    $(".snow-slider-section:first").addClass("first-slider");
    $('.snow-slide').append('<div class="amc-slide-shade"></div>', '<div class="amc-slide-bordered"></div>');
    
    // Product Gallery
    $(".product-gallery__nav li:first").addClass("selected");
    $('.product-gallery__nav > li').on('click', function() {  
        $(this).addClass('selected').siblings('.selected').removeClass('selected');
    });
  
  	// Image Zoom
  	$(".grid .collection-item:not(.snow-block) img, .premium-collection-block img").wrap("<div class='image-focus'></div>");


  $(window).on("message", function(m) {
            if (m.originalEvent.data.type == 'sso') {
                if (m.originalEvent.data.action == 'open') {
                    console.log("Open!")
                } else if (m.originalEvent.data.action == 'close') {
                    console.log("Close!");
                } else {
                  console.log("Not Open or Close");
                }
            }
        });

  
  let loginURL = $(".night-market .sso-modal-login").attr("href");
  let registerURL = $(".night-market .sso-modal-register").attr("href");
  $(".night-market .sso-modal-login").attr("href", loginURL + "pages/nightmarket");
  $(".night-market .sso-modal-register").attr("href", registerURL + "pages/nightmarket");

});